import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["xlink:href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    class: "svg-icon",
    "aria-hidden": "true",
    width: _ctx.size + 'px',
    height: _ctx.size + 'px'
  }, [
    _createElementVNode("use", { "xlink:href": _ctx.iconClass }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}